import React, { Component } 	from "react"
import { withStyles } 			from "material-ui/styles"
import TextField 				from "material-ui/TextField"
import Paper 					from "material-ui/Paper"
import Typography 				from "material-ui/Typography"
import Button 					from "material-ui/Button"
import Snackbar 				from "material-ui/Snackbar"
import Tabs, { Tab } 			from 'material-ui/Tabs'
import IconButton 				from 'material-ui/IconButton'
import Input, {
	InputLabel,
	InputAdornment } 			from 'material-ui/Input'
import {
	FormControl,
	FormHelperText } 			from 'material-ui/Form'
import {
	FormLabel,
	FormControlLabel } 			from 'material-ui/Form'
import Radio, { RadioGroup } 	from 'material-ui/Radio'
import Checkbox 				from 'material-ui/Checkbox'
import Select 					from 'material-ui/Select'
import { MenuItem } 			from 'material-ui/Menu'
import Visibility 				from 'material-ui-icons/Visibility'
import VisibilityOff 			from 'material-ui-icons/VisibilityOff'
import logo 					from "./../static/img/logo.png"
import {
	CardElement,
	CardNumberElement,
	CardExpiryElement,
	CardCVCElement,
	PostalCodeElement,
	PaymentRequestButtonElement,
	StripeProvider,
	Elements,
	injectStripe } 				from 'react-stripe-elements';
import { logInAction } 			from '../actions/authActions'
import { get } 					from '../services/apiServices'
import { post } 				from '../services/apiServices'
import { token } 				from '../services/authServices'

const styles = {
	nomargin: {
		margin: 0
	},
	register: {
		width: "100%",
		maxWidth: "480px",
		margin: "0 auto"
	},
	logo: {
      height: "40px"
    },
	paper: {
		marginTop: "50px",
		marginBottom: "50px",
		padding: "2em"
	},
	formGroup: {
		margin: "40px 0"
	},
	title: {
		margin: 0,
		fontSize: "28px",
		textAlign: "center"
	},
	selectInput: {
		width: "100%"
	},
	subscription: {
		padding: "0 10px 15px",
		borderRadius: "4px",
		boxShadow: "0 0 3px rgba(0, 0, 0, .5)"
	},
	subscriptionHeader: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center"
	},
	subscriptionText: {
		fontSize: "14px",
		lineHeight: "1.4"
	},
	currency: {
		fontSize: "14px"
	},
};

const STRIPE_KEY = process.env.STRIPE_KEY
let formErrors = null

class _SplitForm extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			'open' : false,
			'message' : ''
		}
	}

	handleClose = () => {
		this.setState({'open' : false})
	}

	handleSubmit = ev => {
		ev.preventDefault();
		this.props.stripe.createToken().then(payload => {
			if (payload.token) {
				let data = this.props.data
				let type = data.activeTab ? 'school' : 'family'
				let children = [
					data.form.child_one,
					data.form.child_two,
					data.form.child_three
				]
				let is_adult = data.form.is_adult ? true : false

				post('/auth/register', {
					type : type,
					school_type_id : data.form.school_type_id,
					billing_title : data.form.billing_title,
					billing_first_name : data.form.billing_first_name,
					billing_last_name : data.form.billing_last_name,
					billing_email : data.form.billing_email,
					billing_name : data.form.billing_name,
					title : data.form.title,
					first_name : data.form.first_name,
					last_name : data.form.last_name,
					email : data.form.email,
					password : data.form.password,
					address_1 : data.form.address_1,
					address_2 : data.form.address_2,
					town : data.form.town,
					region : data.form.region,
					postcode : data.form.postcode,
					country_id : data.form.country,
					phone_number : data.form.phone_number,
					children : children,
					currency : data.form.currency,
					discount_code : data.form.discount_code,
					stripe_token : payload.token.id,
					is_adult : is_adult
				}, null, res => {
					let errors = res.data

					this.props.onError(errors.errors)
				}).then(res => {
					let result = res.data

					if (result.data && result.data.token) {
						this.props.logIn(data.form.email, data.form.password)
					} else if (!result.data && result.message) {
						this.setState({
							'open' : true,
							'message' : result.message
						})
					}
				})
			}
		});
	};

	render() {
		let vertical = "top"
		let horizontal = "center"

		return (
			<div>
				<Snackbar
					anchorOrigin={{ vertical, horizontal }}
					open={this.state.open}
					autoHideDuration={4000}
					onClose={this.handleClose}
					SnackbarContentProps={{
						'aria-describedby': 'message-id',
					}}
					message={
						<span id="message-id">
							{this.state.message}
						</span>
					}
				/>
				<form onSubmit={this.handleSubmit}>
					<label>
						<span className="title">Card number</span>
						<CardNumberElement
							placeholder="0000 0000 0000 0000"/>
					</label>
					<label>
						<span className="title">Expiration date</span>
						<CardExpiryElement />
					</label>
					<label>
						<span className="title">CVC</span>
						<CardCVCElement />
					</label>
					<label>
						<span className="title">Postal code</span>
						<PostalCodeElement />
					</label>
					<div className="align-center">
						<br/>
						<Button
							color="primary"
							variant="raised"
							onClick={this.handleSubmit}>
						  Sign Up
						</Button>
					</div>
				</form>
			</div>
		);
	}
}

const SplitForm = injectStripe(_SplitForm);

class Register extends Component {
	constructor(props) {
		super(props)

		this.state = {
			'data' : null,
			'stripe' : null,
			'activeTab' : 0,
			'currencyCode' : '',
			'currencyValue' : 0,
			'form' : {
				'school_type_id' : 0,
				'country' : '',
				'currency' : '',
				'family_plan' : 'year',
				'is_adult' : false
			},
			'errors' : {}
		}
	}

	onError = errors => {
		this.setState({'errors' : errors})
	}

	handleTabChange = (event, value) => {
		let newState = this.state

		newState.activeTab = value
		newState.errors = {}

		this.setState({newState});
	};

	handleInputChange = e => {
		let newState = this.state

		newState.form[e.target.name] = e.target.value;
		newState.errors[e.target.name] ?
			newState.errors[e.target.name] = null : ''

		this.setState({newState})
	}

	handleCountryChange = e => {
		let newState = this.state
		let countryId = e.target.value

		get(`/auth/calculate-subscription/${countryId}`).then(res => {
			if (res.status == 200) {
				let data = res.data
				newState.data.subscription = data.subscription
				newState.form.country = countryId
				newState.errors[e.target.name] = null

				this.setState({newState})
			}
		})
	}

	handleCurrencyChange = e => {
		let newState = this.state
		let currencies = this.state.data.currencies
		let activeCurrency = currencies.filter(currency =>
			currency.id == e.target.value
		)

		newState.form.currency = activeCurrency[0].id
		newState.currencyCode = activeCurrency[0].code
		newState.currencyValue = activeCurrency[0].value

		this.setState(newState)
	}

	handleSchoolTypeChange = e => {
		let newState = this.state
		let schoolTypes = this.state.data.schoolTypes
		let activeSchoolType = schoolTypes.filter(schoolType =>
			schoolType.id == e.target.value
		)

		newState.form.school_type_id = activeSchoolType[0] ?
			activeSchoolType[0].id : 0
		newState.errors.school_type_id = null

		this.setState(newState)
	}

	renderCountriesList = () => {
		let countries = this.state.data ? this.state.data.countries : []
		let result = []

		countries.map(country => {
			result.push(
				<MenuItem
					key={country.id}
					value={country.id}>
					{country.name}
				</MenuItem>
			)
		})

		return result.map(item => item)
	}

	renderCurrenciesList = () => {
		let currencies = this.state.data ? this.state.data.currencies : []
		let result = []

		currencies.map(currency => {
			result.push(
				<MenuItem
					key={currency.id}
					rate={currency.value}
					value={currency.id}>
					{currency.code}
				</MenuItem>
			)
		})

		return result.map(item => item)
	}

	renderSchoolTypesList = () => {
		let schollTypes = this.state.data ? this.state.data.schoolTypes : []
		let result = []

		schollTypes.map(schollType => {
			result.push(
				<MenuItem
					key={schollType.id}
					value={schollType.id}>
					{schollType.name}
				</MenuItem>
			)
		})

		return result.map(item => item)
	}

	componentWillMount() {
		if (window.Stripe) {
			this.setState({stripe: window.Stripe(STRIPE_KEY)});
	    }

		get('/auth/register', token).then(res => {
			let newState = this.state
			newState.data = res.data
			let defaultCountry = newState.data.countries.filter(country =>
				country.is_default == true
			)
			let defaultCurrency = newState.data.currencies.filter(currency =>
				currency.is_default == true
			)

			newState.form.country = defaultCountry[0].id
			newState.form.currency = defaultCurrency[0].id
			newState.currencyCode = defaultCurrency[0].code
			newState.currencyValue = defaultCurrency[0].value

			this.setState(newState)
		})
	}

	classes = this.props.classes

	render() {
		const errors = {...this.state.errors}

		let familyPrice = this.state.data ?
			this.state.data.subscription.family.fullPrice : 0
		let schoolPrice = this.state.data ?
			this.state.data.subscription.school.fullPrice : 0
		let familyVat = this.state.data ?
			this.state.data.subscription.family.vat : 0
		let schoolVat = this.state.data ?
			this.state.data.subscription.school.vat : 0
		let activePrice = this.state.activeTab ? schoolPrice : familyPrice
		let activeVat = this.state.activeTab ? familyVat : schoolVat
		let price = this.state.currencyValue * activePrice
		let subscriptionLabel = this.state.activeTab ?
			"1 year subscription ~ 365 days " : "Family Plan ~ 365 days"
		let is_adultLabel = this.state.activeTab ?
			"I am a teacher or education professional. *" :
			"I am a parent registering a family account *"

		return (
			<div className={this.classes.register}>
				<Paper className={`${this.classes.paper}`}>
					<div className="align-center">
						<img
							alt="Logo"
							className={this.classes.logo}
							src={logo} />
					</div>
					<Tabs
						value={this.state.activeTab}
						onChange={this.handleTabChange}
						indicatorColor="primary"
						textColor="primary"
						centered>
						<Tab label="Family" />
						<Tab label="School" />
					</Tabs>
					<p>We will need to capture some additional details.</p>
					{
						this.state.activeTab ?
						(
							<div className={this.classes.formGroup}>
								<h2 className={this.classes.title}>
									Type of organization
								</h2>
								<FormControl
									error={errors.school_type_id}
									required
									className={this.classes.selectInput}>
									<InputLabel htmlFor="school_type">
										School Type
									</InputLabel>
									<Select
										value={this.state.form.school_type_id}
										onChange={this.handleSchoolTypeChange}
										inputProps={{
											name: 'school_type_id',
											id: 'school_type'
										}}>
										<MenuItem
											key={0}
											value={0}>
											Pick A School Type
										</MenuItem>
										{this.renderSchoolTypesList()}
									</Select>
									{
										errors.school_type_id ?
										(
											<FormHelperText>
												{errors.school_type_id[0]}
											</FormHelperText>
										) : ''
									}
								</FormControl>
							</div>
						) : ''
					}
					<div className={this.classes.formGroup}>
						{
							this.state.activeTab ?
							(
								<h2 className={this.classes.title}>
									Details of the main teacher
								</h2>
							) :
							(
								<h2 className={this.classes.title}>
									Parent's Details
								</h2>
							)
						}
						<TextField
							error={errors.title}
							id="title"
							label="Title"
							name="title"
							value={this.state.form.title}
							onInput={this.handleInputChange}
							margin="normal"
							required
							helperText={
								errors.title ?
									errors.title[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="first_name"
							label="First Name"
							name="first_name"
							value={this.state.form.first_name}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.first_name}
							helperText={
								errors.first_name ?
									errors.first_name[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="last_name"
							label="Last Name"
							name="last_name"
							value={this.state.form.last_name}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.last_name}
							helperText={
								errors.last_name ?
									errors.last_name[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="email"
							label="Email"
							type="email"
							name="email"
							value={this.state.form.email}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.email}
							helperText={
								errors.email ?
									errors.email[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="password"
							label="Password"
							type="password"
							name="password"
							value={this.state.form.password}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.password}
							helperText={
								errors.password ?
									errors.password[0] : ''
							}
							fullWidth
						/>
					</div>
					<div className={this.classes.formGroup}>
						{
							this.state.activeTab ?
							(
								<div>
									<h2 className={this.classes.title}>
										Billing details
									</h2>
									<TextField
										id="billing_title"
										label="Title"
										name="billing_title"
										value={this.state.form.billing_title}
										onInput={this.handleInputChange}
										margin="normal"
										error={errors.billing_title}
										helperText={
											errors.billing_title ?
												errors.billing_title[0] : ''
										}
										fullWidth
									/>
									<TextField
										id="billing_first_name"
										label="First Name"
										name="billing_first_name"
										value={this.state.form.billing_first_name}
										onInput={this.handleInputChange}
										margin="normal"
										required
										error={errors.billing_first_name}
										helperText={
											errors.billing_first_name ?
												errors.billing_first_name[0] : ''
										}
										fullWidth
									/>
									<TextField
										id="billing_last_name"
										label="Last Name"
										name="billing_last_name"
										value={this.state.form.billing_last_name}
										onInput={this.handleInputChange}
										margin="normal"
										required
										error={errors.billing_last_name}
										helperText={
											errors.billing_last_name ?
												errors.billing_last_name[0] : ''
										}
										fullWidth
									/>
									<TextField
										id="billing_email"
										label="Office email for invoice/receipt"
										type="email"
										name="billing_email"
										value={this.state.form.billing_email}
										onInput={this.handleInputChange}
										margin="normal"
										required
										error={errors.billing_email}
										helperText={
											errors.billing_email ?
												errors.billing_email[0] : ''
										}
										fullWidth
									/>
									<TextField
										id="billing_name"
										label="Organisation name"
										name="billing_name"
										value={this.state.form.billing_name}
										onInput={this.handleInputChange}
										margin="normal"
										required
										error={errors.billing_name}
										helperText={
											errors.billing_name ?
												errors.billing_name[0] : ''
										}
										fullWidth
									/>
								</div>
							) :
							(
								<h2 className={this.classes.title}>
									Your Family Home
								</h2>
							)
						}
						<TextField
							id="address_1"
							label="Address Line 1"
							name="address_1"
							value={this.state.form.address_1}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.address_1}
							helperText={
								errors.address_1 ?
									errors.address_1[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="address_2"
							label="Address Line 2"
							name="address_2"
							value={this.state.form.address_2}
							onInput={this.handleInputChange}
							margin="normal"
							error={errors.address_2}
							helperText={
								errors.address_2 ?
									errors.address_2[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="town"
							label="Town"
							name="town"
							value={this.state.form.town}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.town}
							helperText={
								errors.town ?
									errors.town[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="region"
							label="Region"
							name="region"
							value={this.state.form.region}
							onInput={this.handleInputChange}
							margin="normal"
							error={errors.region}
							helperText={
								errors.region ?
									errors.region[0] : ''
							}
							fullWidth
						/>
						<TextField
							id="postcode"
							label="Postcode"
							name="postcode"
							value={this.state.form.postcode}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.postcode}
							helperText={
								errors.postcode ?
									errors.postcode[0] : ''
							}
							fullWidth
						/>
						<FormControl
							required
							className={this.classes.selectInput}
							error={errors.country}>
							<InputLabel htmlFor="country">
								Country
							</InputLabel>
							<Select
								value={this.state.form.country}
								onChange={this.handleCountryChange}
								inputProps={{
									name: 'country',
									id: 'country'
								}}>
								{this.renderCountriesList()}
							</Select>
						</FormControl>
						<TextField
							id="phone_number"
							label="Phone number"
							name="phone_number"
							value={this.state.form.phone_number}
							onInput={this.handleInputChange}
							margin="normal"
							required
							error={errors.phone_number}
							helperText={
								errors.phone_number ?
									errors.phone_number[0] : ''
							}
							fullWidth
						/>
					</div>
					{
						!this.state.activeTab ?
						(
							<div className={this.classes.formGroup}>
								<h2 className={this.classes.title}>
									Children's Accounts
								</h2>
								<p>
									A family membership allows up to three children
									to play, what are the children's full names?
								 </p>
								 <TextField
		 							id="child_one"
		 							label="Child One"
		 							name="child_one"
		 							value={this.state.form.child_one}
		 							onInput={this.handleInputChange}
		 							margin="normal"
									error={errors.child_one}
									helperText={
										errors.child_one ?
											errors.child_one[0] : ''
									}
		 							fullWidth
		 						/>
								<TextField
									id="child_two"
									label="Child Two"
									name="child_two"
									value={this.state.form.child_two}
									onInput={this.handleInputChange}
									margin="normal"
									error={errors.child_two}
									helperText={
										errors.child_two ?
											errors.child_two[0] : ''
									}
									fullWidth
								/>
								<TextField
									id="child_three"
									label="Child Three"
									name="child_three"
									value={this.state.form.child_three}
									onInput={this.handleInputChange}
									margin="normal"
									error={errors.child_three}
									helperText={
										errors.child_three ?
											errors.child_three[0] : ''
									}
									fullWidth
								/>
							</div>
						) : ''
					}
					<div className={this.classes.formGroup}>
						<h2 className={this.classes.title}>
							Available to purchase
						</h2>
						<FormControl className={this.classes.selectInput}>
							<Select
								value={this.state.form.currency}
								onChange={this.handleCurrencyChange}
								inputProps={{
									name: 'currency',
									id: 'currency'
								}}>
								{this.renderCurrenciesList()}
							</Select>
						</FormControl>
						<p className="align-center">Subscription plans</p>
						<div className={this.classes.subscription}>
							<div className={this.classes.subscriptionHeader}>
								<FormControl>
									<RadioGroup
										aria-label="family_plan"
										name="family_plan"
										value={this.state.form.family_plan}
										onChange={this.handleChange}>
										<FormControlLabel
											value="year"
											control={
												<Radio color="primary" />
											}
											label={subscriptionLabel} />
									</RadioGroup>
								</FormControl>
								<span className={this.classes.currency}>
									{`${price.toFixed(2)} ${this.state.currencyCode}`}
								</span>
							</div>
							<div className={this.classes.subscriptionText}>
								{
									this.state.activeTab ?
									(
										<p>
											Includes the paper and online
											version. Using the Android and
											iOS apps requires the Mobile Apps
											bolt-on.
										</p>
									) :
									(
										<p className={this.classes.nomargin}>
											Our 12-month subscription for
											families. The planallows for 3
											children and 2 adults to use the
											website and Apple and Android apps,
											Statsbolt-on and Sessions bolt-on
											(paper versionis not included).
										</p>
									)
								}
								<p className={this.classes.nomargin}>
									Price includes VAT at {activeVat}
								</p>
							</div>
						</div>
						<FormControl required error={errors.is_adult}>
							<FormControlLabel
								control={
									<Checkbox
										checked={this.state.form.checkbox}
										onChange={() => {
											let form = this.state.form
											form.is_adult = !form.is_adult
											this.setState({form})
										}}
										color="primary"
									/>
								}
								label={is_adultLabel}
							/>
							{
								errors.is_adult ?
								(
									<FormHelperText>
										{errors.is_adult[0]}
									</FormHelperText>
								) : ''
							}
						</FormControl>
					</div>
					<div className={this.classes.formGroup}>
						<h2 className={this.classes.title}>
							Discount Code
						</h2>
						<p className="align-center">
							If you have a special discount or special-offer
							code please type it here:
						</p>
						<TextField
							id="discount_code"
							label="Discount code"
							name="discount_code"
							value={this.state.form.discount_code}
							onInput={this.handleInputChange}
							margin="normal"
							error={errors.discount_code}
							helperText={
								errors.discount_code ?
									errors.discount_code[0] : ''
							}
							fullWidth
						/>
					</div>
					<div className={this.classes.formGroup}>
						<p className="align-center">
							Please complete your credit card details below.
						</p>
						<StripeProvider stripe={this.state.stripe}>
							<div className="stripe-form-wrap">
				    			<Elements>
									<SplitForm
										data={this.state}
										onError={this.onError}
										logIn={this.props.logIn} />
				    			</Elements>
				    		</div>
						</StripeProvider>
					</div>
					<div className="align-center">
						<p>
							Already have an account? &nbsp;
							<a href="/login">Sign In</a>
						</p>
					</div>
				</Paper>
			</div>
		)
	}
}

export default withStyles(styles)(Register);



// WEBPACK FOOTER //
// ./src/components/Register.js